Ext.define('SA.VectorMapExportPreviewPage', {
    alias: 'widget.vector-map-export-preview-page',
    extend: 'Ext.container.Container',

    cls: 'sa-export-preview-page',

    initComponent() {
        var model = this.map,
            details = this.details,
            extent = details.getExtent();

        this.callParent();

        this.overlays = this.add([
            {
                xtype: 'vector-map-export-thematic-map-overlay',
                details,
                extent,
                model,
                page: this
            }, {
                xtype: 'vector-map-export-north-arrow-overlay',
                details,
                page: this
            }, {
                xtype: 'vector-map-export-inset-map-overlay',
                details,
                extent,
                model,
                page: this
            }, {
                xtype: 'vector-map-export-scale-bar-overlay',
                details,
                extent,
                model,
                page: this
            }, {
                xtype: 'vector-map-export-legend-overlay',
                details,
                model,
                page: this
            }
        ]);
    },

    initEvents() {
        this.callParent();

        this.overlays.forEach(overlay => {
            overlay.on('afterrender', () => {
                overlay.getEl().on('click', () => this.fireEvent('click:overlay', overlay));
            });

            overlay.on('boxready', () => {
                var {dd: dragger, resizer} = overlay;

                if (dragger) {
                    this.mon(dragger, 'dragend', () => this.fireEvent('usermove:overlay', overlay));
                }

                if (resizer) {
                    this.mon(resizer, 'resize', () => this.fireEvent('userresize:overlay', overlay));

                    resizer.resizeTracker.constrainTo = null;
                }
            });

            overlay.on('show', () => this.fireEvent('show:overlay', overlay));

            this.mon(overlay.getRecord(), 'set:dimensions', this.refresh, this);
            this.mon(overlay.getRecord(), 'set:visible', this.refresh, this);
        });

        this.mon(this.details, 'set:labels', this.refreshTextLabels, this);
    },

    getTextLabels() {
        return this.query('vector-map-export-text-label-overlay');
    },

    refresh() {
        this.overlays.forEach(overlay => {
            var record = overlay.getRecord(),
                details = this.details,
                width = record.getWidth(),
                aspectRatio = record.getAspectRatio(),
                maxWidth = details.getHeight() / (details.getWidth() * aspectRatio),
                pageSize, pageWidth, overlayWidth, overlayHeight;

            if (width > maxWidth) {
                record.setDimensions({width: maxWidth});
                return;
            }

            if (record.isVisible()) {
                overlay.show();

                pageSize = this.getSize();
                pageWidth = pageSize.width;

                overlayWidth = pageWidth * width;

                overlayHeight = Math.round(overlayWidth * record.getAspectRatio());

                overlayWidth = Math.round(overlayWidth);

                overlay.setSize(overlayWidth, overlayHeight);

                overlay.showAt(
                    record.getX() * (pageWidth - overlayWidth),
                    record.getY() * (pageSize.height - overlayHeight)
                );

                overlay.refresh();
            }
            else {
                overlay.hide();
            }
        });

        this.refreshTextLabels();
        this.refreshZOrder();
    },

    refreshTextLabels() {
        var records = this.details.getTextLabels();

        this.getTextLabels().forEach(textLabel => {
            if (!records.includes(textLabel.getRecord())) {
                this.mun(textLabel.getRecord(), 'set:dimensions', this.refreshTextLabels, this);

                this.remove(textLabel);
            }
        });

        records.forEach(record => {
            if (!this.getTextLabels().some(textLabel => record === textLabel.getRecord())) {
                this.add({
                    xtype: 'vector-map-export-text-label-overlay',
                    details: this.details,
                    page: this,
                    record,

                    listeners: {
                        afterrender: label => label.getEl().on('click', () => this.fireEvent('click:textLabel', label)),
                        boxready: label => this.mon(label.dd, 'dragend', () => this.fireEvent('usermove:overlay', label)),
                        move: label => this.fireEvent('move:textLabel', label),
                        resize: label => this.fireEvent('resize:textLabel', label),
                        show: label => this.fireEvent('show:overlay', label)
                    }
                });

                this.mon(record, 'set:dimensions', this.refreshTextLabels, this);
            }
        });

        this.getTextLabels().forEach(textLabel => {
            var record = textLabel.getRecord();

            textLabel.refresh();
            textLabel.showAt(record.getX() * (this.getWidth() - textLabel.getWidth()), record.getY() * (this.getHeight() - textLabel.getHeight()));
        });
    },

    refreshZOrder() {
        this.overlays.slice().reverse().forEach(overlay => {
            if (overlay.isVisible()) {
                overlay.toBack();
            }
        });
    }
});